import React from 'react';
import { useAuth } from '../context/AuthContext';

const TestAdminPage = () => {
  const { currentUser } = useAuth();
  
  const isAdmin = currentUser && currentUser.roles && 
                  currentUser.roles.some(role => role === 'ROLE_ADMIN');

  return (
    <div className="container mt-4">
      <h2>Test Admin Page</h2>
      <div className="alert alert-info">
        <h5>Authentication Status:</h5>
        <p><strong>User:</strong> {currentUser ? currentUser.username : 'Not logged in'}</p>
        <p><strong>Roles:</strong> {currentUser?.roles ? currentUser.roles.join(', ') : 'None'}</p>
        <p><strong>Is Admin:</strong> {isAdmin ? 'Yes' : 'No'}</p>
      </div>
      
      {isAdmin ? (
        <div className="alert alert-success">
          <h5>✅ Admin Access Granted</h5>
          <p>You have admin privileges and should be able to access analytics.</p>
        </div>
      ) : (
        <div className="alert alert-danger">
          <h5>❌ Admin Access Denied</h5>
          <p>You don't have admin privileges.</p>
        </div>
      )}
    </div>
  );
};

export default TestAdminPage;